import { CmsImage, ContainerInner } from '@thisisdevelopment/heritage-core-library';
import styled from 'styled-components';
import theme from 'theme';

export const ContentPageWrapper = styled.div`
  header {
    @media ${theme.mediaQuery.mobile} {
      display: block !important;

      h2 {
        margin-bottom: 10px !important;
        font-size: 1rem !important;
        letter-spacing: 0.1rem !important;
      }
    }
  }
`;

export const ArticleContainer = styled(ContainerInner)`
  margin-top: 80px;
  margin-bottom: 0px;
  padding-bottom: 80px;

  @media ${theme.mediaQuery.mobile} {
    margin-top: 0;
  }
`;

export const MainImage = styled(CmsImage)`
  width: 100%;
  height: auto;
  object-fit: contain;
  margin-top: 70px;

  @media ${theme.mediaQuery.mobile} {
    margin-top: 40px;
  }
`;
